import React from "react";
import { Badge } from "@mui/material";
import type { NotificationAreaCode } from "@/constants/api.notifications";
import { useNotifications } from "@/features/notifications/hooks/useNotifications";
import { notificationAreaHasDedicatedPage } from "@/features/notifications/lib/notificationDedicatedPages";

type NotificationSidebarBadgeProps = {
  section?: NotificationAreaCode;
  children: React.ReactElement;
};

export function NotificationSidebarBadge({
  section,
  children,
}: NotificationSidebarBadgeProps) {
  const { sectionCounts } = useNotifications();
  const count =
    section && notificationAreaHasDedicatedPage(section)
      ? sectionCounts[section] ?? 0
      : 0;

  if (!section || count <= 0) {
    return children;
  }

  return (
    <Badge
      badgeContent={count}
      color="error"
      max={99}
      overlap="circular"
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{
        "& .MuiBadge-badge": {
          fontSize: "0.65rem",
          fontWeight: 700,
          minWidth: 16,
          height: 16,
          px: 0.4,
        },
      }}
    >
      {children}
    </Badge>
  );
}
